<template>
  <div class="row attendance-chat-note justify-center full-width tw-mt-1">
    <div class="col-auto box-note tw-px-3.5 tw-pt-2 tw-pb-1 tw-shadow-sm tw-rounded-[18px] dont-break-out bubble-width">
      <div class="note-title">
        Nota da IA
      </div>
      <div v-if="note.reason">
        <b>Motivo:</b> {{ note.reason }}
      </div>
      <div v-if="note.summary">
        <b>Resumo:</b> {{ note.summary }}
      </div>
      <div
        v-if="time"
        class="box-time text-right tw-mt-1"
      >
        {{ time }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: {
    note: { type: Object, required: true }
  },

  computed: {
    time () {
      return this.note.createdAt ? moment(this.note.createdAt).format('HH:mm') : ''
    }
  }
}
</script>

<style lang="sass">
  .attendance-chat-note
    .box-note
      font-family: Roboto
      font-style: italic
      font-size: 14.2px
      line-height: 19px
      color: rgb(17, 27, 33)
      background-color: #FFF4D6
      border: 1px dashed #C9A227
      text-align: left

    .note-title
      font-weight: 500
      margin-bottom: 2px

    .box-time
      font-size: 11px
      line-height: 13px
      color: #667781

    .dont-break-out
      white-space: pre-wrap
      overflow-wrap: break-word
      word-break: break-word

    .bubble-width
      max-width: min(80%, 560px)
</style>
